export default function () {
  return [
    {
      text: this.$t('common.shortUpdatedBy'),
      value: 'updatedByEmail',
      gravatar: true,
      gravatarTooltip: function gravatarTooltip(item) {
        return `${_.get(item, 'updatedBy', 'system')} ${_.get(item, 'updatedByEmail', '')}`;
      },
    },
    {
      text: this.$t('common.shortUpdatedAt'),
      value: 'updatedAt',
      timeago: true,
    },
  ];
}
